module.exports = __webpack_public_path__ + "img/img-main-bg05M.bfa20d6a.png";